import { Controller } from '@hotwired/stimulus';
import { loadFlag, saveFlag } from '../storage_flag';

// サイドバー大見出しセクション <details> の開閉。「畳んだ」状態のみ localStorage に記憶する
// （既定 closed で「開いた」状態を記憶する nav_collapse_controller とは極性が逆のため別 controller）。
export default class extends Controller {
  static targets = ['badge', 'summaryBadge'];
  static values = { storageKey: String };

  connect() {
    if (this.element.querySelector('.list-group-item.active')) {
      this.element.open = true;
    } else if (loadFlag(this.storageKeyValue)) {
      this.element.open = false;
    }
    this.updateSummaryBadge();
    this.element.addEventListener('toggle', this.onToggle);
  }

  disconnect() {
    this.element.removeEventListener('toggle', this.onToggle);
  }

  onToggle = () => {
    saveFlag(this.storageKeyValue, !this.element.open);
  };

  updateSummaryBadge() {
    if (!this.hasSummaryBadgeTarget) return;

    const total = this.badgeTargets.reduce((sum, badge) => sum + (parseInt(badge.textContent, 10) || 0), 0);
    // 空にすると Bootstrap の .badge:empty で非表示になる
    this.summaryBadgeTarget.textContent = total > 0 ? total : '';
    this.summaryBadgeTarget.classList.toggle(
      'badge-danger',
      this.badgeTargets.some((badge) => badge.classList.contains('badge-danger')),
    );
  }
}
